import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { currencyFormat, dateFormatterForUS } from '../../../utils/formatHelper';
import { getThumbnailImage } from '../../../utils/textHelper';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';
import { REPORT_TYPES } from './consts';
import { getTotalCancellationValue } from '../../pages/Analytics/utils';

export function CancellationTableRow(props) {
  const { row } = props;
  const { sku, ean, upc } = row.identifiers;
  const { visibleColumns } = useSelector((state) => state.analytics.reports[REPORT_TYPES.CANCELLATIONS]);

  const currentGmv = row.gmv[row.currency];
  const rejected =
    row.rejectedUnits === row.partialRejectedUnits ? row.rejectedUnits : row.rejectedUnits + row.partialRejectedUnits;
  const cancelledUnits = row.cancelledUnits + rejected;
  const totalBilled = getTotalCancellationValue(currentGmv);
  const pricePerItem = totalBilled / cancelledUnits;

  const image = row.productImage ? (
    <img src={getThumbnailImage(row.productImage)} alt={row.productName} />
  ) : (
    NO_VALUE_PLACEHOLDER
  );

  return (
    <tr>
      {visibleColumns.includes('image') && <td>{image}</td>}
      <td>{dateFormatterForUS(row.cancellationDate)}</td>
      <td>{dateFormatterForUS(row.orderCreatedDate)}</td>
      <td>{row.retailerName}</td>
      <td>{row.warehouseName}</td>
      <td>{row.countryName}</td>
      {visibleColumns.includes('retailerOrderId') && <td>{row.retailerOrderId ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('salesOrderNumber') && <td>{row.salesOrderNumber ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('sku') && <td>{sku ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('ean') && <td>{ean ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('upc') && <td>{upc ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('model') && <td>{row.model}</td>}
      {visibleColumns.includes('productName') && <td>{row.productName}</td>}
      {visibleColumns.includes('unitsCount') && <td>{row.orderedUnits}</td>}
      {visibleColumns.includes('cancelledUnitsCount') && <td>{cancelledUnits}</td>}
      {visibleColumns.includes('pricePerItem') && <td>{currencyFormat(pricePerItem, row.currency)}</td>}
      {visibleColumns.includes('gmv') && <td>{currencyFormat(totalBilled, row.currency)}</td>}
      {visibleColumns.includes('orderType') && <td>{row.orderType ?? NO_VALUE_PLACEHOLDER}</td>}
    </tr>
  );
}

CancellationTableRow.propTypes = {
  row: PropTypes.shape({
    identifiers: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      ean: PropTypes.string,
      upc: PropTypes.string,
    }).isRequired,
    productImage: PropTypes.string,
    productName: PropTypes.string,
    cancellationDate: PropTypes.string.isRequired,
    orderCreatedDate: PropTypes.string.isRequired,
    retailerName: PropTypes.string.isRequired,
    warehouseName: PropTypes.string,
    retailerOrderId: PropTypes.string.isRequired,
    salesOrderNumber: PropTypes.string,
    model: PropTypes.string.isRequired,
    orderedUnits: PropTypes.number.isRequired,
    cancelledUnits: PropTypes.number.isRequired,
    rejectedUnits: PropTypes.number.isRequired,
    partialRejectedUnits: PropTypes.number.isRequired,
    gmv: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    orderType: PropTypes.string,
  }).isRequired,
};
